module.exports = __webpack_public_path__ + "public/Icons/darkModeOn.svg?a20ffdc6";